<!--
 * @Description: 
 * @Date: 2025-06-22 11:08:41
 * @LastEditors: function
 * @LastEditTime: 2025-06-24 10:50:33
 * @FilePath: \protal-web\src\components\customer\index.vue
-->
<template>
  <div class="customer">
    <div class="items p1">
      <img src="@/assets/images/appDownload.png" width="25px" height="25px" />
      <p>A P P 下载</p>
      <div class="content-scan">
        <img src="@/assets/images/applod.png" width="180px" height="180px"/>
      </div>
    </div>
    <div class="items bgwx p1">
      <img src="@/assets/images/wx.png" width="32px" height="32px" />
      <p>微信客服</p>
      <div class="content-scan">
        <img src="@/assets/images/wxkf.png" width="180px" height="200px" alt=""/>
      </div>
    </div>
    <div class="p1">
      <p class="curp" @click="goTop()"><img src="@/assets/images/top.png" width="45px" height="45px" alt=""/></p>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'index',
  data() {
    return {}
  },
  computed: {
    ...mapState([
      'contact'
    ]),
  },
  methods: {
    goTop () {
      window.scrollTo(0,0);
    }
  }
}
</script>


<style scoped lang="less">
.customer{
  position: fixed;
  width: 45px;
  height: 260px;
  right: 20px;
  z-index: 999;
  top: 40%;
  .items{
    width: 100%;
    background: url("../../assets/images/bgkefu.png") no-repeat center;
    background-size: 100% 100%;
    box-shadow: 0 0 10px rgba(0,0,0,0.3);
    border-radius: 30px;
    margin-bottom: 10px;
    padding: 9px 7px;
    padding-bottom: 12px;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
    p{
      padding: 0 10px;
    }
    &:hover{
      .content-scan{
        display: block;
      }
    }
  }
  .bgwx{
    background: url("../../assets/images/bgwx.png") no-repeat center;
    background-size: 100% 100%;

  }
}
.content-scan{
  display: none;
  background: #fff;
  position: absolute;
  border-radius: 8px;
  right: 55px;
  bottom: 30px;
  padding: 10px;
  min-width: 120px;
  box-shadow: 0 0 40px rgba(79, 122, 253, 15%);
  &:after {
    content: '';
    position: absolute;
    right: -21px;
    bottom: 1px;
    border: 15px solid transparent;
    border-left-color: #fff;
  }
}
</style>